import React, { createContext, useState, useEffect, useContext } from 'react';
// Assicurati che il percorso a firebase.js sia corretto
import { auth, db } from '../firebase'; 
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { Box, CircularProgress } from '@mui/material'; // Per lo spinner

// --- Componente Spinner (puoi spostarlo in un file a parte se vuoi) ---
const LoadingSpinner = () => (
  <Box 
    sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh' 
    }}
  >
    <CircularProgress />
  </Box>
);
// -----------------------------------------------------------------


// 1. Crea il Context
const AuthContext = createContext();

// 2. Crea il Provider (il "contenitore")
export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  // 'true' di default. L'app non si mostra finché non diventa 'false'
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    // Questo listener si attiva al login, al logout e al refresh della pagina
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      
      // --- MODIFICA CHIAVE ---
      // Imposta su 'loading' AD OGNI CAMBIO di stato auth (login/logout)
      // Questo blocca l'UI finché non sappiamo se è admin
      setLoading(true); 
      // -----------------------

      setCurrentUser(user);
      setIsAdmin(false); // Resetta lo stato di admin ad ogni cambio

      if (user) {
        // Utente è loggato, controlla il suo ruolo su Firestore
        try {
          const userDocRef = doc(db, 'users', user.uid);
          const userDoc = await getDoc(userDocRef);
          
          if (userDoc.exists() && userDoc.data().isAdmin === true) {
            setIsAdmin(true); // Imposta l'utente come admin
          }
          // Se non è admin o il doc non esiste, isAdmin rimane false
          
        } catch (error) {
          console.error("Errore nel recuperare i dati utente:", error);
          // Se c'è un errore nel leggere i dati, facciamo logout per sicurezza
          await auth.signOut();
        }
      }
      
      // FONDAMENTALE:
      // Solo ora che sappiamo se l'utente è loggato E se è admin (o no),
      // possiamo dire che il caricamento è finito.
      setLoading(false);
    });

    // Cleanup del listener quando il componente si smonta
    return unsubscribe;
  }, []); // L'array vuoto [] assicura che questo useEffect giri solo una volta

  // Valori da passare a tutti i componenti figli
  const value = {
    currentUser,
    isAdmin,
    loading
  };

  // 3. Logica di "blocco"
  // Finché 'loading' è true, mostra lo spinner e NON il resto dell'app.
  // Questo previene il "flash" della home page.
  if (loading) {
    return <LoadingSpinner />;
  }

  // Quando loading è false, mostra l'app (i children)
  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

// 4. Hook personalizzato per usare il context più facilmente
export function useAuth() {
  return useContext(AuthContext);
}